import {
  Flex,
  Divider,
  Text,
  Box,
  Tooltip,
  AvatarGroup,
  Avatar,
  useTheme,
} from '@chakra-ui/react';
import { NoTeamIcon } from '../../../../icons';
import { Fragment } from 'react';
import CommonLoadingCell from '../LoadingCell/CommonLoadingCell';
import type { Teams } from '../../types/contributorTableTypes';

type Props = {
  teams?: Teams;
  loading: boolean;
  rowHeight?: string;
};

const TeamsCol = ({ teams, loading, rowHeight }: Props) => {
  const { colors } = useTheme();
  return (
    <Flex
      direction="column"
      position="sticky"
      left={0}
      bg="white"
      h={'fit-content'}
      minW="120px"
      zIndex={80}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        borderLeft="1px solid #E0E0E0"
        align="center"
        minH="52px"
        px={4}
        zIndex={50}
      >
        <Flex maxW="180px" w="full" justify="center" align="center">
          <Text
            fontSize="sm"
            fontFamily="heading"
            fontWeight="medium"
            color="text.secondary2"
          >
            Teams
          </Text>
        </Flex>
      </Flex>

      <Divider />

      {loading
        ? [...Array(10)].map((_, index) => (
            <CommonLoadingCell key={index} rowHeight={rowHeight} />
          ))
        : teams?.map((row, index: number) => (
            <Fragment key={`row-${index}`}>
              <Flex
                direction="column"
                align={'center'}
                minH={rowHeight || '110px'}
                p={3}
                bg="white"
                borderLeft="1px solid #E0E0E0"
              >
                {row?.length > 0 ? (
                  <Tooltip
                    label={
                      <Box>
                        {row?.slice(0, 3).map((item: string, idx: number) => (
                          <Text key={idx} fontSize={14}>
                            {item}
                          </Text>
                        ))}
                        {row?.length > 3 ? (
                          <Text>+{row?.length - 3} more</Text>
                        ) : (
                          <></>
                        )}
                      </Box>
                    }
                    hasArrow
                  >
                    <AvatarGroup size="sm" w={'fit-content'}>
                      {row?.slice(0, 3).map((team: string, idx: number) => (
                        <Avatar key={idx} name={team?.trim()} />
                      ))}
                    </AvatarGroup>
                  </Tooltip>
                ) : (
                  <Tooltip label="Not Added To Team" hasArrow>
                    <Box w={7} height={7} mt={1}>
                      <NoTeamIcon height={24} width={24} color={colors.error} />
                    </Box>
                  </Tooltip>
                )}
              </Flex>
              <Divider />
            </Fragment>
          ))}
    </Flex>
  );
};

export default TeamsCol;
